import React, { useEffect, useState } from "react";
import Layout from '../component/Layout';
import { getLabels, updateLabel } from "../adapter/api";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "./AppDetails.css";

const AppDetails = () => {

  const [labels, setlabels] = useState([]);
  const [checkedBusy, setCheckedBusy] = useState(false);
  const [phoneNumber, setPhoneNumber] = useState("");
  const [email, setEmail] = useState("");
  const [location, setLocation] = useState("");
  const [causeTitle, setCauseTitle]=useState("");
  const [causeDescription, setCauseDescription]=useState("");
  const [dollarRate, setDollarRate]=useState("");
  const [deliveryCharge, setDeliveryCharge]=useState("");
  const [aboutUs, setAboutUs]=useState("");
  const [privacyPolicy, setPrivacyPolicy]=useState("");
  const [aboutUsLink, setAboutUsLink]=useState("");
  const [privacyPolicyLink, setPrivacyPolicyLink]=useState("");
  const [baseDeliveryFee, setBaseDeliveryFee]= useState("")
  const [pricePerExtraKm, setPricePerExtraKm]= useState("")
  const [extraKm, setExtraKm]= useState(0.00)
  const [baseKm, setBaseKm]= useState("")

  const listLabels = async () => {
    setlabels([])
    
    const response = await getLabels();

            setlabels(response.data.data)
            setCheckedBusy(response.data.data.acceptOrder)
  
}
useEffect(() => {
    listLabels()
  }, []);

  const handleSaveLabel = async () =>{
    const response = await updateLabel(phoneNumber,location,email,causeTitle,causeDescription,aboutUs,aboutUsLink,privacyPolicy, privacyPolicyLink, dollarRate,deliveryCharge, labels.labelId, baseDeliveryFee, baseKm, pricePerExtraKm, extraKm)
    if(response.status){
      toast.success('Updated Successfully');
    }else{
      toast.console.error('Error');
    }
  }

  useEffect(() => {
    if (labels) {
      setPhoneNumber(labels.phoneNumber || "");
      setLocation(labels.location || "");
      setEmail(labels.email || "")
      setCauseTitle(labels.causeTitle || "");
      setCauseDescription(labels.causeDesc || "");
      setAboutUs(labels.aboutUs || "");
      setPrivacyPolicy(labels.privacyPolicy || "");
      setPrivacyPolicyLink(labels.privacyPolicyLink || "");
      setAboutUsLink(labels.aboutUsLink || "");
      setDollarRate(labels.dollarRate || "");
      setDeliveryCharge(labels.deliveryCharge || "");
      setBaseDeliveryFee(labels.baseDeliveryFee || "");
      setBaseKm(labels.baseKm || "");
      setPricePerExtraKm(labels.pricePerExtraKm || "");
      setExtraKm(labels.extraKm || "")

    }
  }, [labels]);


  return (
    <Layout>
      <ToastContainer />
      <section className="app-details-page" aria-label="App details settings">
        <header className="app-details-header"><div><p className="app-details-eyebrow">SYSTEM SETTINGS</p><h1>App details</h1><p>Control the information and delivery settings shown in the app.</p></div><button className="app-details-save app-details-save-top" onClick={handleSaveLabel}>Save changes</button></header>
        <div className="app-details-grid">
          <section className="app-details-card"><div className="app-details-card-heading"><h2>Business information</h2><p>Contact details and customer-facing content.</p></div><form className="app-details-form">
              <div>
                <label>Phone number</label>
                <input
                  type="text"
                  value={phoneNumber}
                  onChange={(e) => setPhoneNumber(e.target.value)}
                  className="app-details-input"
                />
              </div>
              <div>
                <label>Email</label>
                <input
                  type="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  className="app-details-input"
                />
              </div>
              <div>
                <label>Location</label>
                <input
                  type="text"
                  value={location}
                  onChange={(e) => setLocation(e.target.value)}
                  className="app-details-input"
                />
              </div>
              <div>
                <label>Status</label>
                <div className="app-details-status">
                  <input
                    type="checkbox"
                    checked={checkedBusy}
                    onChange={(e) => setCheckedBusy(e.target.checked)}
                  />
                  <span>Accept orders</span>
                </div>
              </div>
              <div>
                <label>Cause title</label>
                <input
                  type="text"
                  value={causeTitle}
                  onChange={(e) => setCauseTitle(e.target.value)}
                  className="app-details-input"
                />
              </div>
              <div>
                <label>Cause description</label>
                <textarea
                   value={causeDescription}
                   onChange={(e) => setCauseDescription(e.target.value)}
                  className="app-details-input app-details-textarea"
                />
              </div>
            </form></section>
          <section className="app-details-card"><div className="app-details-card-heading"><h2>App &amp; delivery</h2><p>Configure fees, rates, and links displayed to customers.</p></div><form className="app-details-form">
              <div className="app-details-fee-grid">
              <div>
                <label>Base delivery fee</label>
                <input
                  type="text"
                  value={baseDeliveryFee}
                  onChange={(e) => setBaseDeliveryFee(e.target.value)}
                  className="app-details-input"
                />
              </div>
              <div>
                <label>Min. distance (km)</label>
                <input
                  type="number"
                  value={baseKm}
                  onChange={(e) => setBaseKm(e.target.value)}
                  className="app-details-input"
                />
              </div>
              <div>
                <label>Extra km</label>
                <input
                  type="number"
                  value={extraKm !== null ? extraKm.toString() : ""}
                  onChange={(e) => setExtraKm(parseFloat(e.target.value) || 0)}
                  className="app-details-input"
                />
              </div>
              <div>
                <label>Price per extra {extraKm} km</label>
                <input
                  type="text"
                  value={pricePerExtraKm}
                  onChange={(e) => setPricePerExtraKm(e.target.value)}
                  className="app-details-input"
                />
              </div>
              </div>
              <div>
                <label>Dollar rate</label>
                <input
                  type="text"
                  value={dollarRate}
                  onChange={(e) => setDollarRate(e.target.value)}
                  className="app-details-input"
                />
              </div>
            
              <div>
                <label>About us</label>
                <input
                  type="text"
                  value={aboutUsLink}
                  onChange={(e) => setAboutUsLink(e.target.value)}
                  className="app-details-input"
                />
               <span className="app-details-or">OR</span>
                <textarea
                  value={aboutUs}
                  onChange={(e) => setAboutUs(e.target.value)}
                  className="app-details-input app-details-textarea"
                />
              </div>
              <div className="mt-5">
                <label>Privacy policy</label>
                <input
                  type="text"
                  value={privacyPolicyLink}
                  onChange={(e) => setPrivacyPolicyLink(e.target.value)}
                  className="app-details-input"
                />
                <span className="app-details-or">OR</span>
                <textarea
                   value={privacyPolicy}
                   onChange={(e) => setPrivacyPolicy(e.target.value)}
                  className="app-details-input app-details-textarea"
                />
              </div>
            </form></section>
        </div>
        <div className="app-details-save-bottom"><button className="app-details-save" onClick={handleSaveLabel}>Save changes</button></div>
      </section>
    </Layout>
  );
};

export default AppDetails;
